export const offset = offsets => offsets.map(offset => `${offset * 100}%`);

export { default as Container } from './Container.styled';
export { default as Row } from './Row.styled';
export { default as Col } from './Col.styled';
export { default as View } from './View.styled';
